import React from 'react'
import "./SubStyle.css"

const CQC_Mock = () => {
  return (
     <section className="OurServices">
     <h1 className="OurServices-title">Mock Inspections</h1>
      <p className="OurServices-pera">Our comprehensive Mock Inspection service mirrors the CQC inspection process, providing a realistic assessment of your service. We identify strengths, highlight areas requiring improvement, and deliver practical recommendations to help you achieve better inspection outcomes and maintain compliance.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default CQC_Mock
